import { render, staticRenderFns } from "./IcoEye.vue?vue&type=template&id=226e9a12"
import script from "./IcoEye.vue?vue&type=script&lang=js"
export * from "./IcoEye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports